export const contributionModalInitValue = {
  data: {
    date: '',
    totalAmount: 0,
    comments: '',
    file: undefined,
    scriptureView: true,
    lastOperationDate: '',
    contributions: [],
    currentPage: 1,
    rowsPerPage: 10,
    isLoadingContributions: false,
    isLoading: false,
  },
  actions: {
    handleCloseModal(): void {},
    handleChangeDate(): void {},
    handleChangeTotalAmount(): void {},
    handleChangeComments(): void {},
    handleChangeFile(): void {},
    handleChangePage(): void {},
    handleChangeRowsPerPage(): void {},
    handleSaveContribution(): void {},
  },
};
